import type { TFunction } from "i18next";
import { bulkVerdictError } from "@/api/config-server-stages";
import { STREAM_INTERRUPTED_CODE, STREAM_TRANSPORT_ERROR_CODE } from "@/lib/stream-error-codes";
import { errorDetailOr } from "@/lib/api-error";

export function configurationErrorMessage(code: string | undefined, t: TFunction): string | null {
  switch (code) {
    case "item_already_executed": return t("This configuration has already been executed.");
    case "item_conversation_started": return t("A configuration with a started conversation cannot leave scope or return to pending.");
    case "item_not_in_universe": return t("This item is no longer part of the extracted configuration. Refresh the list.");
    case "no_extraction": return t("Run the extraction before changing scope decisions.");
    case "configuration_items_already_executed": return t("A new extraction is not available after the first configuration was executed.");
    case STREAM_INTERRUPTED_CODE:
    case STREAM_TRANSPORT_ERROR_CODE: return t("The run was interrupted before it finished.");
    case "unit_from_diagnostic": return t("This unit comes from the Diagnostic: decide it there and sync.");
    case "parent_from_diagnostic": return t("Approve the parent unit in the Diagnostic first.");
    case "child_from_diagnostic": return t("There are units below it from the Diagnostic: decide them there and sync.");
    default: return null;
  }
}

export function verdictErrorMessage(error: unknown, t: TFunction): string {
  return configurationErrorMessage(bulkVerdictError(error)?.code, t)
    ?? errorDetailOr(error, t("Could not update the scope verdict."));
}
